import { api } from "@/lib/api";
import {
  Subscription,
  SubscriptionInput,
  SubscriptionResponse,
} from "@/types/subscription.types";

export const subscriptionService = {
  async getAllSubscriptions(): Promise<Subscription[]> {
    const response = await api.get<SubscriptionResponse>("/subscriptions");
    return response.data.data;
  },

  async addSubscription(
    subscription: SubscriptionInput
  ): Promise<Subscription> {
    const response = await api.post<Subscription>(
      "/subscriptions",
      subscription
    );
    return response.data;
  },

  async updateSubscription(
    id: string,
    subscription: SubscriptionInput
  ): Promise<Subscription> {
    const response = await api.put<Subscription>(
      `/subscriptions/${id}`,
      subscription
    );
    return response.data;
  },

  async deleteSubscription(id: string): Promise<void> {
    await api.delete(`/subscriptions/${id}`);
  },
};
